document.addEventListener("DOMContentLoaded", function () {
    const productGallery = document.querySelector(".product-single__gallery");
    const productThumbnails = document.querySelector(".product-single__thumbnails");

    if (productGallery && $(productGallery).length) {
        $(productGallery).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: ".product-single__thumbnails",
            infinite: false
        });
    }

    if (productThumbnails && $(productThumbnails).length) {
        $(productThumbnails).slick({
            slidesToShow: 10,
            slidesToScroll: 1,
            asNavFor: ".product-single__gallery",
            dots: false,
            focusOnSelect: true,
            arrows: true,
            vertical: false,
            infinite: false
        });
    }

    if (productGallery && productThumbnails) {
        $(productGallery).slick('slickSetOption', 'asNavFor', '.product-single__thumbnails', true);
        $(productThumbnails).slick('slickSetOption', 'asNavFor', '.product-single__gallery', true);
    }

    if (!customElements.get('media-gallery') || !customElements.get('media-gallery-lite')) {
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.productGallery = this.querySelector(".product-single__gallery");
                this.thumbnailsWrapper = this.querySelector(".thumbnails-wrapper");
                this.productThumbnails = this.thumbnailsWrapper ? this.thumbnailsWrapper.querySelector(".product-single__thumbnails") : {};
                const productVariants = document.getElementById("VariantSelect");
                let mediaId = null;

                if (productVariants) {
                    const currentVariant = productVariants.currentVariant;
                    if (currentVariant && currentVariant.featured_media) {
                        mediaId = currentVariant.featured_media.id;
                    }
                }
                this.initGallerySlider();
                this.initThumbnails();
                this.setActiveMedia(mediaId);
            }

            initGallerySlider() {
                const $productGallery = $(this.productGallery);
                if ($productGallery.hasClass('slick-initialized')) return;
                $productGallery.slick({ arrows: true });
            }

            initThumbnails() {
                this.querySelectorAll(".product-single__thumbnail").forEach(thumb => {
                    thumb.addEventListener("click", (e) => {
                        e.preventDefault();
                        this.setActiveThumbnail(thumb.dataset.thumbnailId);
                    });
                });
            }

            setActiveThumbnail(mediaId) {
                const $slickGallery = $(this.productGallery);
                const $activeThumbnail = this.querySelector(`.product-single__thumbnail[data-thumbnail-id='${mediaId}']`);

                this.querySelectorAll(".product-single__thumbnail").forEach(thumb => {
                    thumb.classList.remove("active-thumb");
                });
                
                if ($activeThumbnail) {
                    $activeThumbnail.classList.add("active-thumb");
                }
                
                const slideIndex = [...this.querySelectorAll(".product-single__thumbnail")].findIndex(el => el.dataset.thumbnailId === mediaId);
                $slickGallery.slick('slickGoTo', slideIndex, true);
            }

            setActiveMedia(mediaId) {
                if (!mediaId) return;
                this.setActiveThumbnail(mediaId);
            }
        }
        customElements.define('media-gallery', MediaGallery);
    }
});